export default "__VITE_ASSET__846eb4a0__"